import { render } from "./FormBlock.vue?vue&type=template&id=03d5949c&scoped=true"
import script from "./FormBlock.vue?vue&type=script&lang=js"
export * from "./FormBlock.vue?vue&type=script&lang=js"

import "./FormBlock.vue?vue&type=style&index=0&id=03d5949c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03d5949c"]])

export default __exports__